import { useState } from 'react';
import { captureMessage } from '@sentry/react';
import Multiselect from 'multiselect-react-dropdown';
import Dropdown from 'react-bootstrap/Dropdown';
import { useToasts } from 'react-toast-notifications';

import './style.scss';
import './style.darkmode.scss';
import NewMessageUserMultiSelect from '../NewMessageUserMultiSelect';

const Exclude = ({
  excluded,
  setExcluded,
  label = "Exclude Users"
}) => {
  const { addToast } = useToasts();

  const [busy, setBusy] = useState(false);
  const handleRemove = (selectedList, removedItem) => {
    setExcluded(selectedList);
  };

  const handleSelect = (selectedList, removedItem) => {
    setExcluded(selectedList);
  };

  const handleSave = async () => {
    setBusy(true);
    await axios.post('/api/messages/excludes', {
      excluded: excluded.map(e => e.id).join(',')
    })
      .then(response => {
        setBusy(false);
        addToast(
          'Exclude successfully saved',
          {
            appearance: 'success',
            autoDismiss: false
          }
        );
      })
      .catch(error => {
        setBusy(false);
        captureMessage(error);
      });
  };

  const handleGetExcluded = (e) => {
    e.preventDefault();

    axios.get('/api/messages/excludes')
      .then(response => {
        setExcluded(response.data);
      })
      .catch(error => {
        captureMessage(error);
      });
  };

  return <div className='broadcast-exlude'>
    <div className="form">
      <div className="input">
        <NewMessageUserMultiSelect
          newMsgSendSelected={excluded}
          setNewMsgSendSelected={handleSelect}
          disabled={false}
          label="Exclude Users"
        />
        <Dropdown className="d-inline mx-2">
          <Dropdown.Toggle id="dropdown-autoclose-true">
            <i className="fa-regular fa-ellipsis-vertical"></i>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item href="#" onClick={handleGetExcluded}>
              Use saved list of excluded users
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
    <div className="actions">
      <button
        className="btn btn-rounded btn-primary mx-2"
        disabled={busy || excluded.length <= 0}
        onClick={handleSave}
      >
        {busy ? 'Saving...' : 'Save Excluded'}
      </button>
    </div>
  </div>;
};

export default Exclude;
